import { render, staticRenderFns } from "./ListApirequestPage.vue?vue&type=template&id=8abbcc80&"
import script from "./ListApirequestPage.vue?vue&type=script&lang=js&"
export * from "./ListApirequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports